import {
  Alert,
  Checkbox,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import type { Dispatch, SetStateAction } from "react";
import type { Fund } from "../../../../../api/types/commonApiTypes";
import type { NewContactState } from "./newContactState";
import { getContactsCountLabel, toggleFundSelectionAction } from "./newContactState";

interface Props {
  state: NewContactState;
  setState: Dispatch<SetStateAction<NewContactState>>;
  funds: Fund[];
}

const FundAccessForm = ({ state, setState, funds }: Props) => {
  return (
    <Stack spacing={2.5}>
      <Alert severity="info">
        <Typography>
          You are adding <strong>{getContactsCountLabel(state)}</strong>
        </Typography>
      </Alert>
      <Stack spacing={1}>
        <Stack spacing={0.5}>
          <Typography variant="subtitle2">Fund Access</Typography>
          <Typography color="textSecondary">Choose the funds you want to give access to.</Typography>
        </Stack>
        <List>
          {funds.map((fund) => (
            <ListItem key={fund.id} dense disablePadding>
              <ListItemButton role={undefined} onClick={() => setState(toggleFundSelectionAction(fund.id))} dense>
                <ListItemIcon sx={{ minWidth: 0 }}>
                  <Checkbox
                    edge="start"
                    tabIndex={-1}
                    disableRipple
                    checked={state.selectedFundIds.includes(fund.id)}
                  />
                </ListItemIcon>
                <ListItemText>
                  <Typography>{fund.name}</Typography>
                </ListItemText>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Stack>
    </Stack>
  );
};

export default FundAccessForm;
